<template>
  <div class="md:max-w-full" v-if="agent">
    <div class="px-4 mx-auto md:max-w-6xl sm:px-8">
      <BreadCrumb :agent="agent" />
    </div>
    <AgentMetaData :agentDetails="agent" />
  </div>
  <div class="mx-auto md:max-w-6xl">
    <div class="md:w-[755px]">
      <DescriptionView :agent="agent" :properties="properties" />
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from "vue";
import BreadCrumb from "@/features/find-broker/agent/BreadCrumb.vue";
import DescriptionView from "@/features/find-broker/agent/DescriptionView.vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import axios from "axios";
import AgentMetaData from "@/features/find-broker/agent/AgentMetaData.vue";
export default {
  components: {
    BreadCrumb,
    DescriptionView,
    AgentMetaData,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const base_url = store.state.baseUrl;
    const agent = ref(null);
    const properties = ref(null);

    onMounted(() => {
      axios
        .get(`${base_url}agent/${route.params.id}`)
        .then((response) => {
          agent.value = response.data.data;
          // console.log(response);
        })
        .catch((error) => console.log(error));

      axios
        .get(`${base_url}properties/agent/${route.params.id}`)
        .then((response) => {
          properties.value = response.data.data;
        })
        .catch((error) => console.log(error));
    });

    return {
      base_url,
      agent,
      properties,
    };
  },
};
</script>
